import { isMainThread } from '../../config/helpers';
import type { Auth } from './baseAuth';
import { WindowAuth } from './windowAuth';
import { WorkerAuth } from './workerAuth';

export type Hash<__T> = string;

export const auth: Auth = isMainThread ? new WindowAuth() : new WorkerAuth();

export type AccessTokens = {
  refresh?: string | null;
  session?: string | null;
  access?: string;
  share?: string;
};

export type AuthState = {
  tokens: AccessTokens;
  hash: Hash<AccessTokens>;
};

export type FetchedAccessTokens = Required<
  Pick<AccessTokens, 'access' | 'session' | 'refresh'>
>;
